import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  dpgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  invalidDpgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  restoreDpgPage: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  dpgDetail: { data: null, loading: false },
  dpgLogs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  allModels: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  allMaterials: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  libModels: { data: [], loading: false },
  libMaterails: { data: [], loading: false },
  libFurnitures: { data: [], loading: false },
  libLogs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  dpjList: { data: [], loading: false },
  dpgOrgs: { data: [], loading: false },
  channelOrgs: { data: [], loading: false },
  ownerBrands: { data: [], loading: false },
  savedFilters: { data: [], loading: false },
  statusTypes: { data: [], loading: false },
  dialog: { type: '', visible: false, loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  search: { pageNum: 1, pageSize: 10 },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
